import { render } from "./UserProfilePage.vue?vue&type=template&id=a2df703e"
import script from "./UserProfilePage.vue?vue&type=script&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__